export default "__VITE_ASSET__C46D5tfu__"